import Colour from '../Colour'
import objToArray from '../../objToArray'
import maybe from '../../maybe'
import that from '../../translationHelper'
import { getPlaceholderImageUrl } from '../../../enums/itemTypePlaceholderImages'

const allColours = 'ALLCOLOURS'
const allSizes = 'ALLSIZES'

const updateItemOwn = (itemOwn, { own, item }) => {
	if (!item.itemKey || (itemOwn && itemOwn.itemKey !== item.itemKey)) {
		return itemOwn
	}
	// create or merge the existing item own
	const updatedItemOwn = {
		...itemOwn,
		...(!!(itemOwn && itemOwn.colourNames) || { itemKey: item.itemKey, colourNames: {} })
	}
	if (own) {
		// add the owned colour
		updatedItemOwn.colourNames[Colour.canonicalName(item.colourName)] = true
	} else if (item.colourName && item.colourName !== allColours) {
		// remove the un-owned colour
		delete updatedItemOwn.colourNames[Colour.canonicalName(item.colourName)]
		// but remove the item own if there are no colours left
		if (!Object.keys(updatedItemOwn.colourNames).length) {
			return false
		}
	} else {
		// delete all, remove the item own
		return false
	}

	return updatedItemOwn
}

const updateItemWant = (itemWant, { want, item }) => {
	if (!item.itemKey || (itemWant && itemWant.itemKey !== item.itemKey)) {
		return itemWant
	}
	// create or merge the existing item want
	const updatedItemWant = {
		...itemWant,
		...(!!(itemWant && itemWant.colourNames) || { itemKey: item.itemKey, colourNames: {} })
	}
	if (want) {
		// add the wanted colour
		updatedItemWant.colourNames[Colour.canonicalName(item.colourName)] = true
	} else if (item.colourName && item.colourName !== allColours) {
		// remove the un-wanted colour
		delete updatedItemWant.colourNames[Colour.canonicalName(item.colourName)]
		// but remove the item want if there are no colours left
		if (!Object.keys(updatedItemWant.colourNames).length) {
			return false
		}
	} else {
		// delete all, remove the item want
		return false
	}

	return updatedItemWant
}

const updateItemsOwned = (itemsOwned = [], { own, item }) => [...maybe([(item.colours || !item.images) ? item : { ...item, colours: [{ colourName: item.colourName, images: item.images }] }], own), ...itemsOwned.filter(i => i.itemKey !== item.itemKey || Colour.canonicalName(i.colourName) !== Colour.canonicalName(item.colourName))]
const updateItemsWanted = (itemsWanted = [], { want, item }) => [...maybe([(item.colours || !item.images) ? item : { ...item, colours: [{ colourName: item.colourName, images: item.images }] }], want), ...itemsWanted.filter(i => i.itemKey !== item.itemKey || Colour.canonicalName(i.colourName) !== Colour.canonicalName(item.colourName))]

const getColour = (item, colourName) => {
	const colourKey = item.colours && Object.keys(item.colours).find(key => Colour.canonicalName(colourName || item.colourName) === Colour.canonicalName(item.colours[key].colourName))
	return colourKey && item.colours[colourKey]
}

const getImages = (item, { colourName } = {}) => { // can pass in the colourName if we have it (and it's not on the item)
	const colour = item.colour || getColour(item, colourName) || (item.colours && item.colours[0])
	let result = colour && objToArray(colour.images)
	if (!result || result.length === 0) {
		result = [{ url: getPlaceholderImageUrl(item.itemType) }]
	}
	return result
}

const getColourName = item => item.colourName || (item.colour && item.colour.colourName) || undefined

const isSameColourName = (colourName, otherColourName) => Colour.canonicalName(colourName) === Colour.canonicalName(otherColourName)
const isSameColour = (item, otherItem) => isSameColourName(getColourName(item), getColourName(otherItem))
const isSameItem = (item, otherItem) => item.itemKey === otherItem.itemKey && isSameColour(item, otherItem)

const isOwned = itemOwnByKey => (item, colour) => {
	const colourName =
		colour || // the passed in colour (from kitItem)
		item.colourName || // the colour from a tagged item
		(item.colour && item.colour.colourName) // the colour object on the item (from algolia, from User/Kit)

	return !!(
		item && itemOwnByKey && itemOwnByKey[item.itemKey] && // item is owned
		(
			!colourName || isSameColourName(colourName, allColours) || // all colours (or no colour) specified
			(itemOwnByKey[item.itemKey].colourNames && itemOwnByKey[item.itemKey].colourNames[Colour.canonicalName(colourName)]) // or this colour is owned
		)
	)
}

const isWanted = itemWantByKey => (item, colour) => {
	const colourName =
		colour || // the passed in colour (from kitItem)
		item.colourName || // the colour from a tagged item
		(item.colour && item.colour.colourName) // the colour object on the item (from algolia, from User/Kit)

	return !!(
		item && itemWantByKey && itemWantByKey[item.itemKey] && // item is wanted
		(
			!colourName || isSameColourName(colourName, allColours) || // all colours (or no colour) specified
			(itemWantByKey[item.itemKey].colourNames && itemWantByKey[item.itemKey].colourNames[Colour.canonicalName(colourName)]) // or this colour is wanted
		)
	)
}

export default {
	allColours,
	allColoursText: that.context.translate('All colours'),
	allSizes,
	allSizesText: that.context.translate('All sizes'),
	isSameItem,
	isSameColour,
	isSameColourName,
	isOwned,
	isWanted,
	updateItemOwn,
	updateItemWant,
	getColour,
	getColourName,
	getImages,
	updateItemsOwned,
	updateItemsWanted
}



// WEBPACK FOOTER //
// ./src/utilities/Data/Item/index.js